module.exports = __webpack_public_path__ + "assets/img/advantage2.d58faddc.png";